import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { history } from "_helpers/history";
import { withTranslation } from "react-i18next";
import { useTranslation } from "react-i18next";
import feliz from "assets/img/luxfeliz.png";
import dudosa from "assets/img/avadudosa.png";
import "./index.scss";
import logo from 'assets/img/logo-secundari.png'
import {Button, Space, Avatar, Row, Col, Menu} from "antd";
import Footer from "../../components/Footer/footer";
import NavbarNoLogin from "../../components/Header/Navbars/NavbarNoLogin";
import LogoComillas from "assets/img/logo-comillas-blanco.png";

function IndexPage(props) {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);

  return (
    <>
      <div className={"headerNoRegister home"}>
        <NavbarNoLogin className="menuNavHome"/>
        <div className={"containerDesc boxed"}>
          <div className={"container-text"}>
            <h1 className={"title"}>{t("home.title")}</h1>
            <p className={"info"}>{t("home.contentmob")}<br/><span>{t("home.content")}</span></p>
            <p className={"registeras fw-medium"}>{t("home.register")}</p>
            <div className={"btnsRegister"}>
              <Button
                href={"/auth/register"}
                className="btn-home btn-tc-blue"
              >
                {t("home.student")}
              </Button>

              <Button
                onClick={() => history.push("/tutorAuth/register")}
                type={"primary"}
                className="btnPrincipal btn-transparent btn-tc-white white btn-home"
              >
                {t("home.tutor")}
              </Button>
            </div>
            <a className={"link fw-medium"} href={"/auth/login"}>{t("menu.inicia")}</a>
          </div>
          <img className={"main-logo"} src={LogoComillas} alt={""} width={343} height={246}/>
        </div>
      </div>
      <div className={"subHeaderNoRegister"}>
        <div className={"boxed"}>
          <h2 className={"center-text"}>{t("home.discover")}</h2>
          <p className={"mission mission--no-space"} dangerouslySetInnerHTML={{__html: t('home.subdiscover')}} />
          <p className={"mission"} dangerouslySetInnerHTML={{__html: t('home.subdiscoverold')}} />
          <div className={"container-items"}>
              <div className={"itemContentUp"}>
                <img className="subHeaderNoRegister-img center-text" src="/assets/img/compass.svg" width={200} height={200} alt={""}/>
                <h3>{t("home.travel")}</h3>
                <p>{t("home.subtravel")}</p>
                <p><strong>{t("home.subtravel2")}</strong></p>
              </div>
              <div className={"itemContentUp"}>
                <img className="subHeaderNoRegister-img center-text" src="/assets/img/questionnaires.svg" width={200} height={200} alt={""}/>
                <h3>{t("home.question")}</h3>
                <p>{t("home.subquestion")}</p>
              </div>
              <div className={"itemContentUp"}>
                <img className="subHeaderNoRegister-img center-text" src="/assets/img/reports.svg" width={200} height={200} alt={""}/>
                <h3>{t("home.report")}</h3>
                <p>{t("home.subreport")}</p>
              </div>
          </div>
        </div>
      </div>
      <div className="blockthree"></div>
      <div className={"blockfour"}>
        <div className={"blockfour-container"}>
          <div className={"content boxed"}>
            <h3>{t("home.queobtiene")}</h3>
            <p>{t("home.queobtienedesc")}</p>
            <img className={"dudosa center-text"} src={"/assets/img/lux-dudosa.svg"} width={538} height={535} alt={""} />
          </div>
        </div>
      </div>
      <div className={"blockfive"}>
        <div className={"blockfive-container"}>
          <div className={"content boxed"}>
            <h3>{t("home.queaporta")}</h3>
            <p>{t("home.queaportadesc")}</p>
            <img className={"reports center-text"} src={"/assets/img/obtienes-reports.svg"} width={441} height={346} alt={""} />          </div>
        </div>
      </div>
      <div className={"blocksix"}>
        <div className={"blocksix-container"}>
          <div className={"content-top boxed"}>
            <div className={"text-top"}>
              <h2>{t("home.unete")}</h2>
              <p>{t("home.unetedesc")}</p>
            </div>
            <div className={"content-register"}>
              <p className={"registeras"}>{t("home.register")}</p>
              <div className={"content-butons"}>
                <Button
                  type={"primary"}
                  href={"/auth/register"}
                  className="btn-home btn-student"
                >
                  {t("home.student")}
                </Button>
                <Button
                  onClick={() => history.push("/tutorAuth/register")}
                  className="btn-home btn-educator btnWhiteBlue"
                >
                  {t("home.tutor")}
                </Button>
              </div>
              <a className={"btn-home btn-login"} href={"/auth/login"}>{t("login.ini")}</a>
            </div>
            <img className={"center-text"}  src={"/assets/img/lux-home.png"}  width={442} height={500} alt={""} />
          </div>
          <div className={"content-bottom boxed"}>
            <h4>{t("home.associates")}</h4>
            <div className={"container-entities"}>
              <img className={"entitie-1"} src={"/assets/img/entidad1.png"} width={150} height={74} alt={""} />
              <img className={"entitie-2"} src={"/assets/img/entidad2.png"} width={223} height={74} alt={""} />
              <img className={"entitie-3"} src={"/assets/img/entidad3.png"} width={238} height={128} alt={""} />
            </div>
          </div>
        </div>
      </div>
      <div className={"blockseven"}>
        <div className={"pre-footer boxed"}>
          <div className={"colum-pre-footer"}>
            <img className={"logop"} src={"/assets/img/logo-primary.png"} width={102} height={56} alt={""}/>
          </div>
          <div className={"colum-pre-footer"}>
            <h4>{t("home.title")}</h4>
            <a href={"/default/index"}>{t("menu.inicio")}</a>
            <a href={"/auth/register"}>{t("menu.alumno")}</a>
            <a href={"/tutorAuth/register"}>{t("menu.educador")}</a>
            <a href={"/auth/login"}>{t("menu.inicia")}</a>
          </div>
          <div className={"colum-pre-footer"}>
            <h4>{t("home.proyectoo")}</h4>
            <a href={"/default/contact"} >{t("menu.contactar")}</a>
            <a href={t("registercenter.directorurl")} target={"_blank"}>{t("menu.proyecto")}</a>
            <a href={"https://www.comillas.edu/"} target={"_blank"}>{t("menu.comillas")}</a>
          </div>
          <div className={"colum-pre-footer"}>
            <h4>{t("home.condiciones")}</h4>
            <a href={t("registercenter.termurl")} target={"_blank"}>{t("menu.terminos")}</a>
            <a href={t("registercenter.poliprivurl")} target={"_blank"}>{t("menu.privacidad")}</a>
            <a href={"https://www.comillas.edu/es/politica-de-cookies"} target={"_blank"}>{t("menu.cookies")}</a>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
export default withTranslation()(IndexPage);
